export default "__VITE_ASSET__DY5esn_l__"